import { useCallback, useEffect, useState } from "react";

import { currenciesArray, DocumentDataField } from "../../constants";
import { useGetDealByIdQuery } from "../../queries/query-selectors/tagger-query-selectors";
import { useTaggerActions, useTaggerDocumentSelector } from "../../store";
import { CurrencyType, IProcessedTag, TaggerDocument } from "../../store/types";

const useCurrency = (docId: TaggerDocument["id"], tag?: IProcessedTag) => {
  const doc = useTaggerDocumentSelector(docId);
  const { changeDocumentData } = useTaggerActions();

  const { data: deal, isLoading } = useGetDealByIdQuery(doc.dealId);

  const defaultDealCurrency = deal?.currency?.data?.find((curr) => curr.is_default)?.value as CurrencyType;

  const options = currenciesArray.map((curr) => ({ label: curr, value: curr }));

  const [value, setValue] = useState<CurrencyType | null>(null);

  const handleChange = useCallback(
    (value: CurrencyType | null) => {
      setValue(value);
      changeDocumentData(docId, DocumentDataField.SelectedCurrency, value);
    },
    [docId, changeDocumentData]
  );

  useEffect(() => {
    setValue(tag?.currency ?? defaultDealCurrency ?? null);
  }, [tag, defaultDealCurrency]);

  return {
    value: value,
    options: options,
    loading: isLoading,
    onChange: handleChange
  };
};

export default useCurrency;
